import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { FiArrowRight, FiArrowUpRight, FiCheck } from "react-icons/fi";
import Frame from "../layout/Frame";
import Meta from "../layout/Meta";
import Invite from "../blocks/Invite";
import services, { getService } from "../db/services";

const pad = (n) => String(n).padStart(2, "0");

const Service = () => {
  const { slug } = useParams();
  const svc = getService(slug);
  if (!svc) return <Navigate to="/services" replace />;
  const others = services.filter((s) => s.slug !== slug).slice(0, 3);

  return (
    <Frame>
      <Meta title={svc.title} description={svc.short} />
      <section className="svc-hero">
        <div className="shell">
          <div className="crumb">
            <Link to="/">Home</Link><span className="sep">/</span>
            <Link to="/services">Services</Link><span className="sep">/</span>{svc.slug}
          </div>
          <span className="tag tag--orange">{svc.code}</span>
          <h1 style={{ marginTop: "1.25rem" }}>{svc.title}</h1>
          <p className="lede">{svc.short}</p>
        </div>
      </section>
      <section className="band">
        <div className="shell">
          <div className="svc-body">
            <div className="prose">
              <p>{svc.detail}</p>
              <div style={{ marginTop: "2.25rem" }}>
                <Link to="/contact" className="btn btn--orange">Brief this service <FiArrowRight /></Link>
              </div>
            </div>
            <aside>
              <div className="panel">
                <h4>WHAT WE BUILD</h4>
                <ul className="tick">
                  {svc.deliverables.map((d, i) => (
                    <li key={i}><span className="m"><FiCheck /></span><span>{d}</span></li>
                  ))}
                </ul>
              </div>
            </aside>
          </div>
          <div className="also">
            <div className="head-block">
              <div className="left">
                <span className="tag">ALSO RELEVANT</span>
                <h2 style={{ marginTop: "1rem", fontSize: "1.8rem" }}>Services often combined.</h2>
              </div>
            </div>
            <div className="services">
              {others.map((s) => {
                const i = services.findIndex((x) => x.slug === s.slug);
                return (
                  <Link key={s.slug} to={`/services/${s.slug}`} className="service">
                    <div className="num">{pad(i + 1)}</div>
                    <div>
                      <div className="code">{s.code}</div>
                      <h3>{s.title}</h3>
                      <p>{s.short}</p>
                      <span className="more">Read service <FiArrowUpRight /></span>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </section>
      <Invite />
    </Frame>
  );
};

export default Service;
